import React, { useContext } from 'react'
import AccessContext from '../../context/AccessContext/AccessContext';
import ErrorScreen from '../MessagesScreens/ErrorScreen'
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const EmployeeNoAccess = () => {
    const { clean, accessState } = useContext(AccessContext);
    const { message } = accessState

    const navigate = useNavigate();

    const getBackAndClean = () => {
        navigate('/dashboard');
        clean();
    }

    return (
        <div>
            <ErrorScreen
                title={'Error'}
                description={message}
                withButton={true}
                buttonTitle={t('FINISH')}
                onClickButton={() => getBackAndClean()}
            />
        </div>
    )
}

export default EmployeeNoAccess